import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import "./itemlists.css";
import axios from "axios";
import BASE_URL from "../../../config/apiConfig";
import {
  faCircleUser,
  faLeaf,
  faRmb,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function ItemLists({ type }) {
  const [userCount, setUserCount] = useState(0);
  const [adminUserCount, setAdminUserCount] = useState(0);
  const [cropCount, setCropCount] = useState(0);
  const [farmCount, setFarmCount] = useState(0);
  const [loading, setLoading] = useState(true);

  // Fetch the counts for users and admin users from the backend
  useEffect(() => {
    const fetchCounts = async () => {
      try {
        // Fetch user count
        const userResponse = await axios.get(`${BASE_URL}/api/admin/users`);
        console.log("User API Response:", userResponse.data); // Log the response to check data structure
        setUserCount(userResponse.data.length); // Assuming the API returns an array of users

        // Fetch admin user count
        const adminUserResponse = await axios.get(
          `${BASE_URL}/api/admin/admin-users`
        );
        console.log("Admin User API Response:", adminUserResponse.data); // Log the response to check data structure
        setAdminUserCount(adminUserResponse.data.length); // Assuming the API returns an array of admin users

        // Fetch crop count
        // const cropCountResponse = await axios.get(
        //   `${BASE_URL}/api/admin/crops`
        // );
        // console.log("Crop API Response:", cropCountResponse.data); // Log the response to check data structure
        // setCropCount(cropCountResponse.data.length); // Assuming the API returns an array of crops

        const farmCountResponse = await axios.get(
          `${BASE_URL}/api/admin/farms`
        );
        console.log("Farm API Response:", farmCountResponse.data); // Log the response to check data structure
        setFarmCount(farmCountResponse.data.length); // Assuming the API returns an array of crops

        setLoading(false); // Set loading to false when the data is fetched
      } catch (error) {
        console.error("Error fetching user and admin counts:", error);
        setLoading(false); // Even if there is an error, we stop the loading state
      }
    };

    fetchCounts();
  }, []);

  let data;

  // Dynamically change the UI content based on the type
  switch (type) {
    case "admin":
      data = {
        title: "ADMIN USERS",
        isMoney: false,
        count: adminUserCount, // Ensure adminUserCount is used here
        icon: (
          <FontAwesomeIcon
            icon={faCircleUser}
            style={{
              color: "#2E3A59", // Dark blue-gray for the icon
              backgroundColor: "#F0F2F5", // Light grayish-blue for the background
            }}
            className="icon"
          />
        ),
        link: "See all admin users",
        linkto: "/admin/all-admins",
      };
      break;
    case "user":
      data = {
        title: "USERS",
        isMoney: false,
        count: userCount,
        icon: (
          <PermIdentityIcon
            style={{
              color: "#4CAF50", // Soft green for the user icon
              backgroundColor: "#E8F5E9", // Pale green tint for the background
            }}
            className="icon"
          />
        ),
        link: "See all users",
        linkto: "/admin/users",
      };
      break;
    case "crop":
      data = {
        title: "CROPS",
        isMoney: false,
        count: cropCount,
        icon: (
          <FontAwesomeIcon
            icon={faLeaf}
            style={{
              color: "#00A86B",
              backgroundColor: "#C5E1A5",
            }}
            className="icon"
          />
        ),
        link: "See all crops",
        linkto: "/admin/crops",
      };
      break;
    case "farms":
      data = {
        title: "Farms",
        isMoney: false,
        count: farmCount,
        icon: (
          <FontAwesomeIcon
            icon={faRmb}
            style={{
              color: "#00A86B",
              backgroundColor: "#C5E1A5",
            }}
            className="icon"
          />
        ),
        link: "See all Farms",
        linkto: "/admin/farms",
      };

      break;
    default:
      // If no valid type is provided, set a fallback object to avoid "undefined" errors
      data = {
        title: "UNKNOWN TYPE",
        isMoney: false,
        count: 0,
        icon: <div>No Icon</div>,
        link: "No data available",
        linkto: "#",
      };
      break;
  }

  if (loading) {
    return <p>Loading...</p>; // Display a loading message while data is being fetched
  }

  return (
    <div className="item_listss">
      <div className="name">
        <p>Total {data.title}</p>
        {/* <span className="persentage positive">
                    <KeyboardArrowUpIcon />
                    20 %
                </span> */}
      </div>

      <div className="counts">
        {data.isMoney && <AttachMoneyOutlinedIcon />}
        {data.count}
      </div>

      <div className="see_item">
        <Link to={data.linkto}>
          <p>{data.link}</p>
        </Link>
        {data.icon}
      </div>
    </div>
  );
}

export default ItemLists;
